import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint, MustPreloadLoadableNames } from '@confluence/loadable';

export const EditPageLoaderServer: LoadableType<{
	contentId: string;
	spaceKey: string;
	draftShareId?: string;
	contentType: string;
}> = LoadablePaint({
	name: 'EditPageLoaderServer',
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EditPageLoaderServer" */ '../src/edit-page-loader/EditPageLoaderServer.tsx'
			)
		).EditPageLoaderServer,
	_mustPreloadWhenRenderingSPA: [
		MustPreloadLoadableNames.ClassicEditorContextProviderLoader,
		MustPreloadLoadableNames.NativeCollabLoader,
		MustPreloadLoadableNames.FullPageEditorLoader,
	],
});
